<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits(["update:modelValue"]);

function update(event: Event) {
  const input = event.target as HTMLInputElement;

  emit("update:modelValue", input.checked);
}
</script>

<template>
  <label class="base-search-exact">
    <input type="checkbox" :checked="modelValue" @change="update" />
    <span>{{ t("common.labels.search_exact") }}</span>
  </label>
</template>

<style lang="scss" scoped>
.base-search-exact {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  width: fit-content;
  cursor: pointer;
  user-select: none;

  input {
    width: 1rem;
    height: 1rem;
    accent-color: var(--primary);
    cursor: pointer;
  }

  span {
    font-size: 0.875rem;
    color: var(--text-medium);
  }
}
</style>
